import { render, staticRenderFns } from "./ShareWhatsapp.vue?vue&type=template&id=2a5d4cc8&scoped=true&"
import script from "./ShareWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ShareWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5d4cc8",
  null
  
)

export default component.exports